import ReviewItem from '../components/ReviewItem';
import { useLocation } from 'react-router-dom';

function Comment({ data }) {
  const location = useLocation();
  // console.log(location.state.id);

  return (
    <div>
      Comment
      <ReviewItem id={location.state.id} />
    </div>
  );
}

export default Comment;
